export default {
  '& math': {
    display: 'inline-block',
    padding: '2px 6px',
    background: 'rgba(255, 235, 0, 0.1)',
  },
};
